import { render } from "./EditPersonnellePage2.vue?vue&type=template&id=2963fdf2&ts=true"
import script from "./EditPersonnellePage2.vue?vue&type=script&lang=ts"
export * from "./EditPersonnellePage2.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__